import { api } from './api'

export class FetchEventSource {
  private readonly url: string
  private readonly eventListeners: Record<string, ((event: MessageEvent) => void)[]>
  private abortController: AbortController

  constructor(url: string) {
    this.url = api.defaults.baseURL + url
    this.eventListeners = {}
    this.abortController = new AbortController()
  }

  addEventListener(type: string, listener: (event: MessageEvent) => void) {
    if (!this.eventListeners[type]) {
      this.eventListeners[type] = []
    }
    this.eventListeners[type].push(listener)
  }

  close() {
    this.abortController.abort()
  }

  async connect(body?: any) {
    try {
      const response = await fetch(this.url, {
        method: body ? 'POST' : 'GET',
        body: JSON.stringify(body),
        credentials: 'include',
        signal: this.abortController.signal,
        headers: {
          Accept: 'text/event-stream',
          'Content-Type': 'application/json',
        },
      })

      if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`)
      }

      if (!response.body) {
        throw new Error('No body')
      }

      const reader = response.body.getReader()
      let partialData = ''

      while (true) {
        const { done, value } = await reader.read()

        if (done) {
          break
        }

        const chunk = new TextDecoder('utf-8').decode(value)
        partialData += chunk

        const messages = partialData.split('\n\n')
        for (let i = 0; i < messages.length - 1; i++) {
          this.parseMessage(messages[i])
        }
        partialData = messages[messages.length - 1]
      }
    } catch (error) {
      this.dispatchEvent(new MessageEvent('error', { data: error })) // dispatch error if any
    }
  }

  private parseMessage(message: string) {
    console.log({ message })
    if (message.startsWith('data: ')) {
      const data = message.substring('data: '.length)
      this.dispatchEvent(new MessageEvent('message', { data }))
    } else if (message.includes('event: close')) {
      const eventType = message.substring('event: '.length).trim().split('\n')[0]
      const dataIndex = message.indexOf('\ndata: ')

      let data = ''
      if (dataIndex !== -1) {
        data = message.substring(dataIndex + '\ndata: '.length)
      }

      console.log({ eventType, dataIndex, data })

      this.dispatchEvent(new MessageEvent(eventType, { data }))
    }
  }

  private dispatchEvent(event: MessageEvent) {
    const listeners = this.eventListeners[event.type]
    if (listeners) {
      listeners.forEach((listener) => listener(event))
    }
  }
}
